import { createSelector } from '@ngrx/store';
import { selectThemeState } from '../..';

export const selectTheme = createSelector(selectThemeState, (state) => state.theme);

export const selectIsDark = createSelector(selectThemeState, (state) => state.theme === 'azdhs-dark');
